var _jsxFileName = "/codebuild/output/src2856833513/src/bitbucket.org/newyuinc/adc-polaris-web/src/components/utility/CountryBottomSheetModal/index.tsx";
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { BottomSheet, Divider, RadioListItem, ScrollView, Stack } from '@adc/parallax-component-library';
import i18n from 'Utilities/i18n';
const CountryBottomSheetModal = ({
  isOpen,
  onCancel,
  onDone,
  countries,
  selectedCountry,
  title
}) => {
  const [selectedItem, setSelectedItem] = useState('');
  const ref = useRef(null);
  useEffect(() => {
    if (isOpen) {
      var _ref$current;
      (_ref$current = ref.current) === null || _ref$current === void 0 || _ref$current.present();
    } else {
      var _ref$current2;
      (_ref$current2 = ref.current) === null || _ref$current2 === void 0 || _ref$current2.dismiss();
    }
  }, [isOpen]);
  useEffect(() => {
    if (selectedCountry && isOpen) {
      setSelectedItem(selectedCountry);
    }
  }, [selectedCountry, isOpen]);
  const orderedCountryList = useMemo(() => {
    const allCountries = countries || [];
    return allCountries.filter(country => i18n.exists(`Global.microcopy.countries.${country.toUpperCase()}`)).map(country => ({
      code: country.toUpperCase(),
      name: i18n.t(`Global.microcopy.countries.${country.toUpperCase()}`)
    })).sort((a, b) => a.name.localeCompare(b.name));
  }, [countries]);
  const handleCancelAction = useCallback(() => {
    setSelectedItem('');
    onCancel();
  }, [onCancel]);
  const handleDone = useCallback(() => {
    if (selectedItem) {
      onDone(selectedItem);
      if (ref && 'current' in ref && ref.current) {
        ref.current.close();
      }
    } else {
      onCancel();
    }
  }, [selectedItem, onDone, onCancel]);
  return /*#__PURE__*/React.createElement("div", {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 80,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(BottomSheet, {
    topNavigationProps: {
      title,
      buttonStart: {
        element: i18n.t('Global.microcopy.common.cancel').toString(),
        onPress: handleCancelAction,
        label: i18n.t('Global.microcopy.common.cancel')
      },
      buttonEnd: {
        element: i18n.t('Global.microcopy.common.done').toString(),
        onPress: handleDone,
        label: i18n.t('Global.microcopy.common.done')
      }
    },
    snapPoints: ['99%'],
    ref: ref,
    onBackdropClick: handleCancelAction,
    onDismiss: handleCancelAction,
    scrollable: false,
    testID: "CountryBottomSheetModal",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 81,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(ScrollView, {
    nestedScrollEnabled: true,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 103,
      columnNumber: 9
    }
  }, orderedCountryList.map(({
    code,
    name
  }) => {
    return /*#__PURE__*/React.createElement(Stack, {
      key: code,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 106,
        columnNumber: 15
      }
    }, /*#__PURE__*/React.createElement(RadioListItem, {
      key: code,
      title: name,
      "aria-label": name,
      disabled: false,
      selected: selectedItem === code,
      onPress: () => setSelectedItem(code),
      testID: `Country.${code}`,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 107,
        columnNumber: 17
      }
    }), /*#__PURE__*/React.createElement(Divider, {
      borderColor: "$neutral.20",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 116,
        columnNumber: 17
      }
    }));
  }))));
};
export { CountryBottomSheetModal };